module.exports = __webpack_public_path__ + "img/noResults.53e98bb9.svg";